// =======================
// src/index.js
// =======================
import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { ThemeProvider, createTheme } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import { CondicaoProvider } from "./contexto";
import { FonteProvider } from "./contextos/FonteContext";
import App from "./App";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { tipografiaGlobal } from "./estilos/global";

// Criando um tema personalizado
const theme = createTheme({
  typography: tipografiaGlobal,
  palette: {
    primary: {
      main: "#2196f3",
    },
    secondary: {
      main: "#f50057",
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <CondicaoProvider>
      <ThemeProvider theme={theme}>
        <FonteProvider>
          {" "}
          {/* Fornecendo o tema para a aplicação */}
          <CssBaseline /> {/* Normalizando os estilos base */}
          <BrowserRouter>
            <App /> {/* Renderizando o componente de rotas */}
          </BrowserRouter>
        </FonteProvider>
      </ThemeProvider>
    </CondicaoProvider>
  </React.StrictMode>,
);
